module.exports = __webpack_public_path__ + "img/1x1.5e54f61d.svg";